module.exports = __webpack_public_path__ + "media/images/brand/people03-55d7a7ece0e922a9a2a390c8621798a9.png";